import { f7 } from 'framework7-react';
import { FC } from 'react';
import style from './serviceCategorySectionStyle.module.css';
import { paths } from '@/config/paths';
import { UserActionCategory } from '@/types/api/serviceApi';
import IconCategoryCar from '@/assets/images/menu/icon-category-car.svg';
import IconCategoryMaintenance from '@/assets/images/menu/icon-category-maintenance.svg';
import IconCategoryShop from '@/assets/images/menu/icon-category-shop.svg';
import IconCategoryRentCar from '@/assets/images/menu/icon-category-rent-car.svg';

// 親カテゴリーのアイコンマッピング（固定）
const CATEGORY_ICON_MAP: Record<string, string> = {
  '売却・購入する': IconCategoryCar,
  'メンテナンスする': IconCategoryMaintenance,
  '買う': IconCategoryShop,
  '借りる': IconCategoryRentCar,
};

interface ServiceCategorySectionProps {
  category: UserActionCategory;
  id?: string;
}

export const ServiceCategorySection: FC<ServiceCategorySectionProps> = ({
  category,
  id,
}) => {
  if (
    !category.m_mt_service_categories ||
    category.m_mt_service_categories.length === 0
  ) {
    return null;
  }

  const handleServiceClick = (serviceCategoryId: number, name: string) => {
    f7.views.main.router.navigate(
      paths.serviceCategory(serviceCategoryId.toString()),
      { props: { categoryName: name } },
    );
  };

  return (
    <div id={id} className={style['section-wrapper']}>
      <div className={style['section-header']}>
        <img
          src={CATEGORY_ICON_MAP[category.name]}
          alt={category.name}
          className={style['section-icon']}
        />
        <span className={style['section-title']}>{category.name}</span>
      </div>

      <div className={style['service-grid']}>
        {category.m_mt_service_categories.map((serviceCategory) => (
          <button
            key={serviceCategory.id}
            className={`${style['service-button']} ${
              serviceCategory.disable_flg ? style['disabled'] : ''
            }`}
            onClick={() =>
              !serviceCategory.disable_flg &&
              handleServiceClick(serviceCategory.id, serviceCategory.name)
            }
            disabled={serviceCategory.disable_flg}
          >
            {serviceCategory.name}
          </button>
        ))}
      </div>
    </div>
  );
};
